import React from 'react';

interface MeetingsIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const MeetingsIcon: React.FC<MeetingsIconProps> = ({ className, size = 24, color = 'currentColor' }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="5" width="18" height="16" rx="2" stroke={color} strokeWidth="1.6" />
    <path d="M3 9.5H21" stroke={color} strokeWidth="1.6" />
    <path d="M8 3V6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M16 3V6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="9" cy="14.5" r="1.4" fill={color} />
    <circle cx="15" cy="14.5" r="1.4" fill={color} />
    <path d="M6.8 18.5C7.2 17.4 8 16.8 9 16.8C10 16.8 10.8 17.4 11.2 18.5" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
    <path d="M12.8 18.5C13.2 17.4 14 16.8 15 16.8C16 16.8 16.8 17.4 17.2 18.5" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

export default MeetingsIcon;
